import { render, staticRenderFns } from "./order111.vue?vue&type=template&id=6bbc1782"
import script from "./order111.vue?vue&type=script&lang=js"
export * from "./order111.vue?vue&type=script&lang=js"
import style0 from "./order111.vue?vue&type=style&index=0&id=6bbc1782&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports